/**
 * SGKC010A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Sgkc010aReqTankatableApprvInfoDto {

    /**
     * 単価表登録管理通番
     */
    tankatableregistrationManagementserialnumber?: string;
    /**
     * 単価表コード
     */
    tankatableCode?: string;
    /**
     * 更新通番号
     */
    updateSrno?: string;
}

